document.addEventListener('DOMContentLoaded', function () {
  initReveal();
  initColores();
  initGaleriaProducto();
  initVariantes();
  initComparador();
  initEvitarDobleEnvio();
});

function initReveal() {
  var els = document.querySelectorAll('.wn-reveal, .wn-reveal-stagger');
  if (!els.length) return;
  if (!('IntersectionObserver' in window)) {
    els.forEach(function (el) { el.classList.add('wn-visible'); });
    return;
  }
  var obs = new IntersectionObserver(function (entries) {
    entries.forEach(function (entry) {
      if (entry.isIntersecting) {
        entry.target.classList.add('wn-visible');
        obs.unobserve(entry.target);
      }
    });
  }, { threshold: 0.15, rootMargin: '0px 0px -40px 0px' });
  els.forEach(function (el) { obs.observe(el); });
}

function initColores() {
  document.querySelectorAll('[data-wn-colores]').forEach(function (bloque) {
    var swatches = bloque.querySelectorAll('.wn-swatch');
    var imgs = bloque.querySelectorAll('.wn-colores-visual img');
    swatches.forEach(function (btn) {
      btn.addEventListener('click', function () {
        var color = btn.getAttribute('data-color');
        swatches.forEach(function (b) { b.classList.remove('wn-activo'); });
        btn.classList.add('wn-activo');
        imgs.forEach(function (img) {
          img.classList.toggle('wn-activo', img.getAttribute('data-color') === color);
        });
      });
    });
  });
}

function initGaleriaProducto() {
  document.querySelectorAll('[data-wn-galeria]').forEach(function (bloque) {
    var principal = bloque.querySelector('.wn-galeria-principal img');
    var thumbs = bloque.querySelectorAll('.wn-galeria-thumb');
    if (!principal || !thumbs.length) return;
    thumbs.forEach(function (thumb) {
      thumb.addEventListener('click', function () {
        var full = thumb.getAttribute('data-full');
        if (!full) return;
        principal.setAttribute('src', full);
        thumbs.forEach(function (t) { t.classList.remove('wn-activo'); });
        thumb.classList.add('wn-activo');
      });
    });
  });
}

function initEvitarDobleEnvio() {
  document.querySelectorAll('[data-wn-producto-form]').forEach(function (form) {
    form.addEventListener('submit', function () {
      var boton = form.querySelector('[data-wn-add-cart]');
      if (!boton || boton.disabled) return;
      boton.dataset.textoOriginal = boton.textContent;
      boton.disabled = true;
      boton.textContent = 'Añadiendo...';
    });
  });
}

function initVariantes() {
  document.querySelectorAll('[data-wn-producto-form]').forEach(function (form) {
    var dataEl = form.querySelector('[data-wn-variantes-json]');
    if (!dataEl) return;
    var variantes;
    try { variantes = JSON.parse(dataEl.textContent); } catch (e) { return; }

    var idInput = form.querySelector('input[name="id"]');
    var precioEl = form.querySelector('[data-wn-precio-actual]');
    var comparadoEl = form.querySelector('[data-wn-precio-comparado]');
    var addBtn = form.querySelector('[data-wn-add-cart]');
    var pills = form.querySelectorAll('.wn-opcion-pill');

    function opcionesSeleccionadas() {
      var seleccion = [];
      form.querySelectorAll('.wn-opcion-bloque').forEach(function (bloque) {
        var activo = bloque.querySelector('.wn-opcion-pill.wn-activo');
        if (activo) seleccion.push(activo.getAttribute('data-valor'));
      });
      return seleccion;
    }

    function encontrarVariante() {
      var seleccion = opcionesSeleccionadas();
      return variantes.find(function (v) {
        return v.options.length === seleccion.length && v.options.every(function (o, i) { return o === seleccion[i]; });
      });
    }

    function formatoMoneda(centavos) {
      return (centavos / 100).toLocaleString(document.documentElement.lang || 'es-ES', { minimumFractionDigits: 2, maximumFractionDigits: 2 });
    }

    function actualizar() {
      var variante = encontrarVariante();
      if (!variante) return;
      idInput.value = variante.id;
      if (precioEl) precioEl.textContent = formatoMoneda(variante.price);
      if (comparadoEl) {
        if (variante.compare_at_price && variante.compare_at_price > variante.price) {
          comparadoEl.textContent = formatoMoneda(variante.compare_at_price);
          comparadoEl.style.display = '';
        } else {
          comparadoEl.style.display = 'none';
        }
      }
      if (addBtn) {
        if (variante.available) {
          addBtn.disabled = false;
          addBtn.textContent = addBtn.getAttribute('data-texto-disponible') || addBtn.textContent;
        } else {
          addBtn.disabled = true;
          addBtn.textContent = addBtn.getAttribute('data-texto-agotado') || 'Agotado';
        }
      }
      var imagenVariante = document.querySelector('[data-wn-galeria-raiz] .wn-galeria-thumb[data-variant-valor="' + variante.options[0] + '"]');
      if (imagenVariante) imagenVariante.click();
    }

    pills.forEach(function (pill) {
      pill.addEventListener('click', function () {
        var bloque = pill.closest('.wn-opcion-bloque');
        bloque.querySelectorAll('.wn-opcion-pill').forEach(function (p) { p.classList.remove('wn-activo'); });
        pill.classList.add('wn-activo');
        actualizar();
      });
    });

    actualizar();
  });
}

function initComparador() {
  document.querySelectorAll('[data-wn-comparador]').forEach(function (raiz) {
    var contenedor = raiz.querySelector('.wn-comparador-imgs');
    var clip = raiz.querySelector('[data-wn-comparador-clip]');
    var handle = raiz.querySelector('[data-wn-comparador-handle]');
    if (!contenedor || !clip || !handle) return;

    var arrastrando = false;

    function fijarPorcentaje(pct) {
      pct = Math.max(0, Math.min(100, pct));
      clip.style.clipPath = 'inset(0 ' + (100 - pct) + '% 0 0)';
      handle.style.left = pct + '%';
      handle.setAttribute('aria-valuenow', Math.round(pct));
    }

    function posicionDesdeEvento(clientX) {
      var rect = contenedor.getBoundingClientRect();
      var pct = ((clientX - rect.left) / rect.width) * 100;
      fijarPorcentaje(pct);
    }

    function mover(e) {
      if (!arrastrando) return;
      var clientX = e.touches ? e.touches[0].clientX : e.clientX;
      posicionDesdeEvento(clientX);
    }

    function soltar() {
      arrastrando = false;
    }

    handle.addEventListener('mousedown', function () { arrastrando = true; });
    handle.addEventListener('touchstart', function () { arrastrando = true; }, { passive: true });
    contenedor.addEventListener('click', function (e) { posicionDesdeEvento(e.clientX); });
    window.addEventListener('mousemove', mover);
    window.addEventListener('touchmove', mover, { passive: true });
    window.addEventListener('mouseup', soltar);
    window.addEventListener('touchend', soltar);

    handle.addEventListener('keydown', function (e) {
      var actual = parseFloat(handle.style.left) || 50;
      if (e.key === 'ArrowLeft') { fijarPorcentaje(actual - 5); e.preventDefault(); }
      if (e.key === 'ArrowRight') { fijarPorcentaje(actual + 5); e.preventDefault(); }
    });

    fijarPorcentaje(50);
  });
}
